import { NotificationEventList } from "components/notification-event/NotificationEventList";
import { Provider } from "components/notification-event/NotificationEventContext";
export const NotificationEvents = () => {
    return (
        <Provider>
            <NotificationEventList />
        </Provider>
    );
};
